import * as React from "react";
import { type IColumn } from "@fluentui/react";
import { makeObservable, computed } from "mobx";
import { observer } from "mobx-react";
import { type UUID } from "../../utils/uuid";
import { type ShockProfile } from "../../api";
import { mGtoG } from "../../utils/unit-conversion";

export interface ListShockProfileItemCellProps {
    readonly shockProfileId: UUID;
    readonly column: IColumn;
}

import { store } from "../../store";

@observer
export class ListShockProfileItemCell extends React.Component<ListShockProfileItemCellProps> {
    constructor(props: ListShockProfileItemCellProps) {
        super(props);
        makeObservable(this);
    }

    @computed private get shockProfile(): ShockProfile | undefined {
        return store.repositoryShockProfiles.byId(this.props.shockProfileId);
    }

    public render(): JSX.Element {
        const { column } = this.props;
        switch (column.key) {
            case "label":
                return <span>{this.shockProfile?.label ?? ""}</span>;
            case "light":
                return (
                    <span>{store.i18n.formatFloat(mGtoG(this.shockProfile?.light), 3) ?? ""}</span>
                );
            case "medium":
                return (
                    <span>{store.i18n.formatFloat(mGtoG(this.shockProfile?.medium), 3) ?? ""}</span>
                );
            case "severe":
                return (
                    <span>{store.i18n.formatFloat(mGtoG(this.shockProfile?.severe), 3) ?? ""}</span>
                );
            case "duration":
                return <span>{store.i18n.formatFloat(this.shockProfile?.duration, 0) ?? ""}</span>;
            case "xAxisScale":
                return (
                    <span>{store.i18n.formatFloat(this.shockProfile?.xAxisScale, 6) ?? ""}</span>
                );
            case "yAxisScale":
                return (
                    <span>{store.i18n.formatFloat(this.shockProfile?.yAxisScale, 6) ?? ""}</span>
                );
            case "zAxisScale":
                return (
                    <span>{store.i18n.formatFloat(this.shockProfile?.zAxisScale, 6) ?? ""}</span>
                );
            default:
                return <></>;
        }
    }
}
